import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bell, Timer, Radio, Youtube, Globe, Heart, Menu, X } from 'lucide-react';

export default function Navigation() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-blue-800/50 backdrop-blur-sm border-b border-blue-700/50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" onClick={closeMobileMenu}>
            <img src="/logo.png" alt="Clock Online Logo" className="h-8 md:h-12" style={{width: 'auto'}} />
            <span className="text-2xl font-bold text-white" style={{position: 'absolute', left: '-99999px'}}>Clock Online</span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-4 xl:gap-6">
            <NavButton
              icon={Bell}
              label="Alarms"
              to="/"
              active={location.pathname === '/'}
            />
            <NavButton
              icon={Radio}
              label="Radio Alarm"
              to="/radio-alarm"
              active={location.pathname === '/radio-alarm'}
            />
            <NavButton
              icon={Youtube}
              label="Video Alarm"
              to="/video-alarm"
              active={location.pathname === '/video-alarm'}
            />
            <NavButton
              icon={Timer}
              label="Timers"
              to="/timers"
              active={location.pathname === '/timers'}
            />
            <NavButton
              icon={Heart}
              label="Meditation"
              to="/meditation"
              active={location.pathname === '/meditation'}
            />
            <NavButton
              icon={Globe}
              label="World Clock"
              to="/world-clock"
              active={location.pathname === '/world-clock'}
            />
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-blue-700/50 hover:bg-blue-600/50 transition-colors"
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-white" />
            ) : (
              <Menu className="w-6 h-6 text-white" />
            )}
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        <div className={`lg:hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen 
            ? 'max-h-96 opacity-100 mt-4' 
            : 'max-h-0 opacity-0 overflow-hidden'
        }`}>
          <div className="bg-blue-900/80 backdrop-blur-sm rounded-lg border border-blue-600/30 p-4">
            <div className="grid grid-cols-2 gap-3">
              <MobileNavButton
                icon={Bell}
                label="Alarms"
                to="/"
                active={location.pathname === '/'}
                onClick={closeMobileMenu}
              />
              <MobileNavButton
                icon={Radio}
                label="Radio"
                to="/radio-alarm"
                active={location.pathname === '/radio-alarm'}
                onClick={closeMobileMenu}
              />
              <MobileNavButton
                icon={Youtube}
                label="Video"
                to="/video-alarm"
                active={location.pathname === '/video-alarm'}
                onClick={closeMobileMenu}
              />
              <MobileNavButton
                icon={Timer}
                label="Timers"
                to="/timers"
                active={location.pathname === '/timers'}
                onClick={closeMobileMenu}
              />
              <MobileNavButton
                icon={Heart}
                label="Meditation"
                to="/meditation"
                active={location.pathname === '/meditation'}
                onClick={closeMobileMenu}
              />
              <MobileNavButton
                icon={Globe}
                label="World Clock"
                to="/world-clock"
                active={location.pathname === '/world-clock'}
                onClick={closeMobileMenu}
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

function NavButton({ icon: Icon, label, to, active }) {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors text-sm xl:text-base ${
        active
          ? 'bg-cyan-500 text-white'
          : 'text-white hover:bg-blue-700/50'
      }`}
    >
      <Icon className="w-4 h-4 xl:w-5 xl:h-5" />
      <span className="font-semibold hidden xl:inline">{label}</span>
      <span className="font-semibold xl:hidden text-xs">{label.split(' ')[0]}</span>
    </Link>
  );
}

function MobileNavButton({ icon: Icon, label, to, active, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`flex flex-col items-center gap-2 p-3 rounded-lg transition-colors ${
        active
          ? 'bg-cyan-500 text-white'
          : 'text-white hover:bg-blue-700/50'
      }`}
    >
      <Icon className="w-6 h-6" />
      <span className="font-semibold text-xs text-center">{label}</span>
    </Link>
  );
}